import { Expandable } from './Expandable.js'

import { trapFocus } from "./trapFocus";

export class Footer {
    constructor(params) {
        this.params = params
        this.$el = document.querySelector('footer[role="contentinfo"]')
    }
    initAccordions() {
        this.footerRegionsArr = document.querySelectorAll(this.params.accordions.regionsSelector)
        
        this.footerRegionsArr.forEach($region => {
            new Expandable($region)
        })
        
        this.desktopDisplayQuery = window.matchMedia(this.params.accordions.desktopBreakpoint) // while the media query is true, menu is displayed as mobile

        // set listener...
        this.desktopDisplayQuery.addEventListener('change', this.onDesktopDisplayQueryChange.bind(this), {capture: false, passive: true, once: false} || false)
        // ...then trigger it once
        this.onDesktopDisplayQueryChange(this.desktopDisplayQuery)
    }
    init() {
        // Store handles to DOM
        if (this.params.accordions) this.initAccordions()
    }
    onDesktopDisplayQueryChange(e) {
        if (e.matches === false) { // mobile
            this.footerRegionsArr.forEach(_$region => {
                _$region.expandable.enable()
                _$region.expandable.close()
            })
        } else { //desktop
            this.footerRegionsArr.forEach(_$region => {
                _$region.expandable.open()
                _$region.expandable.disable()
            })
        }
    }
}


    
